var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBusiness4(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    preserveAspectRatio: "xMidYMid meet",
    viewBox: "0 0 48 55",
    width: 48,
    height: 55,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M41 23C41 23 41 23 41 23C41 23.6 41 23.93 41 24C41 24 41 24 41 24C39.2 24 38.2 24 38 24C38 24 38 24 38 24C38 23.4 38 23.07 38 23C38 23 38 23 38 23C39.8 23 40.8 23 41 23Z",
    id: "a6zpDVYgi"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41 32C41 32 41 32 41 32C41 32.6 41 32.93 41 33C41 33 41 33 41 33C39.2 33 38.2 33 38 33C38 33 38 33 38 33C38 32.4 38 32.07 38 32C38 32 38 32 38 32C39.8 32 40.8 32 41 32Z",
    id: "d2qK2INX2K"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 28C9 28 9 28 9 28C9 28.6 9 28.93 9 29C9 29 9 29 9 29C7.8 29 7.13 29 7 29C7 29 7 29 7 29C7 28.4 7 28.07 7 28C7 28 7 28 7 28C8.2 28 8.87 28 9 28Z",
    id: "c4yfZR7VO"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 19C11 19 11 19 11 19C11 19.6 11 19.93 11 20C11 20 11 20 11 20C8.6 20 7.27 20 7 20C7 20 7 20 7 20C7 19.4 7 19.07 7 19C7 19 7 19 7 19C9.4 19 10.73 19 11 19Z",
    id: "d199dz972x"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36 13L36.59 14L33 14L33 13L36 13Z",
    id: "b3j944AsKF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.79 14L12.21 13L17 13L17 14L10.79 14Z",
    id: "e1FDZVF39a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.21 13L33.21 16L38 16L39 17L32.79 17L29.79 14L22 14L22 13L30.21 13Z",
    id: "a3ihvbH2br"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.79 42L15.79 39L11 39L10 38L16.21 38L19.21 41L27 41L27 42L18.79 42Z",
    id: "a5ldvK6Md1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33 39L33 38L38 38L37 39L33 39Z",
    id: "b8NhrdNl5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32 42L32 41L36 41L35 42L32 42Z",
    id: "a2tb55KCUG"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13 42L12 41L16 41L16 42L13 42Z",
    id: "d1vrQRbFce"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36 23.5C36 24.33 36.67 25 37.5 25C38.33 25 39 24.33 39 23.5C39 22.67 38.33 22 37.5 22C36.67 22 36 22.67 36 23.5ZM37 23.5C37 23.22 37.22 23 37.5 23C37.78 23 38 23.22 38 23.5C38 23.78 37.78 24 37.5 24C37.22 24 37 23.78 37 23.5Z",
    id: "aFZW1CxLA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36 32.5C36 33.33 36.67 34 37.5 34C38.33 34 39 33.33 39 32.5C39 31.67 38.33 31 37.5 31C36.67 31 36 31.67 36 32.5ZM37 32.5C37 32.22 37.22 32 37.5 32C37.78 32 38 32.22 38 32.5C38 32.78 37.78 33 37.5 33C37.22 33 37 32.78 37 32.5Z",
    id: "d1p909BEBK"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 28.5C8 29.33 8.67 30 9.5 30C10.33 30 11 29.33 11 28.5C11 27.67 10.33 27 9.5 27C8.67 27 8 27.67 8 28.5ZM9 28.5C9 28.22 9.22 28 9.5 28C9.78 28 10 28.22 10 28.5C10 28.78 9.78 29 9.5 29C9.22 29 9 28.78 9 28.5Z",
    id: "aMgJu9cA4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 19.5C10 20.33 10.67 21 11.5 21C12.33 21 13 20.33 13 19.5C13 18.67 12.33 18 11.5 18C10.67 18 10 18.67 10 19.5ZM11 19.5C11 19.22 11.22 19 11.5 19C11.78 19 12 19.22 12 19.5C12 19.78 11.78 20 11.5 20C11.22 20 11 19.78 11 19.5Z",
    id: "e2ZCu1HXpt"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.79 13.5C19.79 14.33 20.47 15 21.29 15C22.12 15 22.79 14.33 22.79 13.5C22.79 12.67 22.12 12 21.29 12C20.47 12 19.79 12.67 19.79 13.5ZM20.79 13.5C20.79 13.22 21.02 13 21.29 13C21.57 13 21.79 13.22 21.79 13.5C21.79 13.78 21.57 14 21.29 14C21.02 14 20.79 13.78 20.79 13.5Z",
    id: "bCpvny4vL"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 13.5C16 14.33 16.67 15 17.5 15C18.33 15 19 14.33 19 13.5C19 12.67 18.33 12 17.5 12C16.67 12 16 12.67 16 13.5ZM17 13.5C17 13.22 17.22 13 17.5 13C17.78 13 18 13.22 18 13.5C18 13.78 17.78 14 17.5 14C17.22 14 17 13.78 17 13.5Z",
    id: "a6GqiD99WI"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30 41.5C30 42.33 30.67 43 31.5 43C32.33 43 33 42.33 33 41.5C33 40.67 32.33 40 31.5 40C30.67 40 30 40.67 30 41.5ZM31 41.5C31 41.22 31.22 41 31.5 41C31.78 41 32 41.22 32 41.5C32 41.78 31.78 42 31.5 42C31.22 42 31 41.78 31 41.5Z",
    id: "a1KlQkbVW"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26 41.5C26 42.33 26.67 43 27.5 43C28.33 43 29 42.33 29 41.5C29 40.67 28.33 40 27.5 40C26.67 40 26 40.67 26 41.5ZM27 41.5C27 41.22 27.22 41 27.5 41C27.78 41 28 41.22 28 41.5C28 41.78 27.78 42 27.5 42C27.22 42 27 41.78 27 41.5Z",
    id: "b17zfaCLCZ"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.35 9.27C35.21 13.19 37.6 16.57 41 18.7C41 19.43 41 25.27 41 26C41 40.96 28.46 46.92 24 48.66C19.54 46.92 7 40.96 7 26C7 25.27 7 19.43 7 18.7C10.41 16.57 12.79 13.19 13.65 9.27C14.34 9.13 17.79 8.42 24 7.15L24 7.15C30.21 8.42 33.66 9.13 34.35 9.27ZM23.8 6.17L13.45 8.3L12.81 8.43C12.73 8.81 12.68 9.02 12.67 9.06C11.86 12.74 9.66 15.86 6.47 17.85C6.44 17.87 6.28 17.97 6 18.14L6 18.7C6 23.08 6 25.51 6 26C6 41.08 18.33 47.52 23.64 49.59C23.66 49.6 23.78 49.65 24 49.73C24.22 49.65 24.34 49.6 24.36 49.59C29.67 47.52 42 41.08 42 26C42 25.51 42 23.08 42 18.7L42 18.14C41.72 17.96 41.56 17.87 41.53 17.85C38.34 15.86 36.14 12.74 35.33 9.06C35.32 9.02 35.27 8.81 35.19 8.42L34.56 8.29L24.2 6.17L24 6.13L24 6.13L23.8 6.17Z",
    id: "bqodI617n"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.03 5.21C39.01 5.48 39 5.74 39 6C39 10.42 41.84 14.23 46 15.53C46 16.58 46 24.95 46 26C46 35.19 42.45 42.69 35.44 48.29C30.83 51.98 25.15 53.59 24 53.95C21.56 53.18 2 46.64 2 26C2 24.95 2 16.58 2 15.53C6.16 14.23 9 10.42 9 6C9 5.74 8.99 5.48 8.97 5.21C9.97 5 14.98 3.93 24 2.02L24 2.02C33.02 3.93 38.03 5 39.03 5.21ZM23.79 1.04L8.76 4.23L7.9 4.42C7.94 4.94 7.96 5.24 7.97 5.29C7.99 5.53 8 5.77 8 6C8 9.95 5.47 13.4 1.7 14.58C1.66 14.59 1.42 14.66 1 14.8L1 15.53C1 21.81 1 25.3 1 26C1 46.69 19.91 53.71 23.7 54.91C23.72 54.91 23.82 54.94 24 55L24.3 54.91C24.43 54.87 24.5 54.84 24.52 54.84C29.18 53.41 33.07 51.47 36.06 49.07C43.32 43.27 47 35.51 47 26C47 25.3 47 21.81 47 15.53L47 14.8C46.58 14.66 46.34 14.59 46.3 14.58C42.53 13.4 40 9.95 40 6C40 5.76 40.01 5.53 40.03 5.3C40.04 5.24 40.06 4.95 40.11 4.42L39.24 4.23L24.21 1.04L24 1L24 1L23.79 1.04Z",
    id: "d1wsvOf9F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45 17C45 17 45 17 45 17C45 18.2 45 18.86 45 19C45 19 45 19 45 19C43.8 19 43.13 19 43 19C43 19 43 19 43 19C43 17.8 43 17.13 43 17C43 17 43 17 43 17C44.2 17 44.87 17 45 17Z",
    id: "a1yEDPduPd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 17C5 17 5 17 5 17C5 18.2 5 18.86 5 19C5 19 5 19 5 19C3.8 19 3.13 19 3 19C3 19 3 19 3 19C3 17.8 3 17.13 3 17C3 17 3 17 3 17C4.2 17 4.87 17 5 17Z",
    id: "a5tXc35NsD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 6C12 6 12 6 12 6C12 7.2 12 7.86 12 8C12 8 12 8 12 8C10.8 8 10.13 8 10 8C10 8 10 8 10 8C10 6.8 10 6.13 10 6C10 6 10 6 10 6C11.2 6 11.87 6 12 6Z",
    id: "bPeSbbE8B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38 6C38 6 38 6 38 6C38 7.2 38 7.86 38 8C38 8 38 8 38 8C36.8 8 36.13 8 36 8C36 8 36 8 36 8C36 6.8 36 6.13 36 6C36 6 36 6 36 6C37.2 6 37.87 6 38 6Z",
    id: "h1jpdOtRn8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44 32C44 32 44 32 44 32C44 33.2 44 33.86 44 34C44 34 44 34 44 34C42.8 34 42.13 34 42 34C42 34 42 34 42 34C42 32.8 42 32.13 42 32C42 32 42 32 42 32C43.2 32 43.87 32 44 32Z",
    id: "f9zHCw1C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 32C6 32 6 32 6 32C6 33.2 6 33.86 6 34C6 34 6 34 6 34C4.8 34 4.13 34 4 34C4 34 4 34 4 34C4 32.8 4 32.13 4 32C4 32 4 32 4 32C5.2 32 5.87 32 6 32Z",
    id: "b1dyZssYCn"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13 44C13 44 13 44 13 44C13 45.2 13 45.86 13 46C13 46 13 46 13 46C11.8 46 11.13 46 11 46C11 46 11 46 11 46C11 44.8 11 44.13 11 44C11 44 11 44 11 44C12.2 44 12.87 44 13 44Z",
    id: "a9cqDJkns"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37 44C37 44 37 44 37 44C37 45.2 37 45.86 37 46C37 46 37 46 37 46C35.8 46 35.13 46 35 46C35 46 35 46 35 46C35 44.8 35 44.13 35 44C35 44 35 44 35 44C36.2 44 36.87 44 37 44Z",
    id: "c5e9sC1CkN"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25 51C25 51 25 51 25 51C25 52.2 25 52.86 25 53C25 53 25 53 25 53C23.8 53 23.13 53 23 53C23 53 23 53 23 53C23 51.8 23 51.13 23 51C23 51 23 51 23 51C24.2 51 24.87 51 25 51Z",
    id: "d1cbGEY2NI"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25 3C25 3 25 3 25 3C25 4.2 25 4.86 25 5C25 5 25 5 25 5C23.8 5 23.13 5 23 5C23 5 23 5 23 5C23 3.8 23 3.13 23 3C23 3 23 3 23 3C24.2 3 24.87 3 25 3Z",
    id: "aIxqSOAnv"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41 29C38.22 29 36.67 29 36.36 29C36.32 29.34 36.26 29.67 36.19 30C36.51 30 38.11 30 41 30L41 29Z",
    id: "a1fdB6OIeh"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41 26C38.26 26 36.74 26 36.44 26C36.47 26.33 36.48 26.66 36.49 27C36.79 27 38.29 27 41 27L41 26Z",
    id: "f4pirTn0S"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40 35C36.28 35 34.21 35 33.8 35C33.52 35.35 33.23 35.68 32.92 36C33.33 36 35.35 36 39 36L40 35Z",
    id: "djF0Z5nSx"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41 19C36.42 19 33.88 19 33.38 19C33.66 19.32 33.92 19.65 34.17 20C34.63 20 36.9 20 41 20L41 19Z",
    id: "a1WMym957V"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 33C10.54 33 12.51 33 12.91 33C12.74 32.67 12.58 32.34 12.44 32C12.08 32 10.26 32 7 32L7 33Z",
    id: "a8Uovt1iw"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 23C10.15 23 11.91 23 12.26 23C12.38 22.66 12.52 22.33 12.67 22C12.29 22 10.4 22 7 22L7 23Z",
    id: "aC75yFrlW"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 36C12.65 36 14.67 36 15.08 36C14.77 35.68 14.48 35.35 14.2 35C13.79 35 11.72 35 8 35L9 36Z",
    id: "b2tAMyc3P"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 26C9.74 26 11.26 26 11.56 26C11.6 25.66 11.65 25.33 11.71 25C11.4 25 9.83 25 7 25L7 26Z",
    id: "d22jpcMPgQ"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 17C13.71 17 16.33 17 16.86 17C17.4 16.62 17.98 16.29 18.58 16C17.94 16 14.75 16 9 16L9 17Z",
    id: "a6cE3bCkJk"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5 27.25C12.5 20.91 17.66 15.75 24 15.75C30.34 15.75 35.5 20.91 35.5 27.25C35.5 33.59 30.34 38.75 24 38.75C17.66 38.75 12.5 33.59 12.5 27.25ZM13.5 27.25C13.5 33.04 18.21 37.75 24 37.75C29.79 37.75 34.5 33.04 34.5 27.25C34.5 21.46 29.79 16.75 24 16.75C18.21 16.75 13.5 21.46 13.5 27.25Z",
    id: "b9JqJmZ18"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23 31L20 26L17 26L23 34L31 22L29 22L23 31Z",
    id: "mcy2EgNJB"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a6zpDVYgi",
    opacity: 1,
    fill: "#010101",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a6zpDVYgi",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#d2qK2INX2K",
    opacity: 1,
    fill: "#010101",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#d2qK2INX2K",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#c4yfZR7VO",
    opacity: 1,
    fill: "#010101",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#c4yfZR7VO",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#d199dz972x",
    opacity: 1,
    fill: "#010101",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#d199dz972x",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b3j944AsKF",
    opacity: 1,
    fill: "#010101",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b3j944AsKF",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#e1FDZVF39a",
    opacity: 1,
    fill: "#010101",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#e1FDZVF39a",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a3ihvbH2br",
    opacity: 1,
    fill: "#010101",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a3ihvbH2br",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a5ldvK6Md1",
    opacity: 1,
    fill: "#010101",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a5ldvK6Md1",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b8NhrdNl5",
    opacity: 1,
    fill: "#010101",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b8NhrdNl5",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a2tb55KCUG",
    opacity: 1,
    fill: "#010101",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a2tb55KCUG",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#d1vrQRbFce",
    opacity: 1,
    fill: "#010101",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#d1vrQRbFce",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#aFZW1CxLA",
    opacity: 1,
    fill: "#010101",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#aFZW1CxLA",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#d1p909BEBK",
    opacity: 1,
    fill: "#010101",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#d1p909BEBK",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#aMgJu9cA4",
    opacity: 1,
    fill: "#010101",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#aMgJu9cA4",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#e2ZCu1HXpt",
    opacity: 1,
    fill: "#010101",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#e2ZCu1HXpt",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#bCpvny4vL",
    opacity: 1,
    fill: "#010101",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#bCpvny4vL",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a6GqiD99WI",
    opacity: 1,
    fill: "#010101",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a6GqiD99WI",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a1KlQkbVW",
    opacity: 1,
    fill: "#010101",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a1KlQkbVW",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b17zfaCLCZ",
    opacity: 1,
    fill: "#010101",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b17zfaCLCZ",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#bqodI617n",
    opacity: 1,
    fill: "#010101",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#bqodI617n",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#d1wsvOf9F4",
    opacity: 1,
    fill: "#010101",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#d1wsvOf9F4",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a1yEDPduPd",
    opacity: 1,
    fill: "#010101",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a1yEDPduPd",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a5tXc35NsD",
    opacity: 1,
    fill: "#010101",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a5tXc35NsD",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#bPeSbbE8B",
    opacity: 1,
    fill: "#010101",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#bPeSbbE8B",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#h1jpdOtRn8",
    opacity: 1,
    fill: "#010101",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#h1jpdOtRn8",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#f9zHCw1C",
    opacity: 1,
    fill: "#010101",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#f9zHCw1C",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b1dyZssYCn",
    opacity: 1,
    fill: "#010101",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b1dyZssYCn",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a9cqDJkns",
    opacity: 1,
    fill: "#010101",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a9cqDJkns",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#c5e9sC1CkN",
    opacity: 1,
    fill: "#010101",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#c5e9sC1CkN",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#d1cbGEY2NI",
    opacity: 1,
    fill: "#010101",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#d1cbGEY2NI",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#aIxqSOAnv",
    opacity: 1,
    fill: "#010101",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#aIxqSOAnv",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a1fdB6OIeh",
    opacity: 1,
    fill: "#010101",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a1fdB6OIeh",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#f4pirTn0S",
    opacity: 1,
    fill: "#010101",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#f4pirTn0S",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#djF0Z5nSx",
    opacity: 1,
    fill: "#010101",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#djF0Z5nSx",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a1WMym957V",
    opacity: 1,
    fill: "#010101",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a1WMym957V",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a8Uovt1iw",
    opacity: 1,
    fill: "#010101",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a8Uovt1iw",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#aC75yFrlW",
    opacity: 1,
    fill: "#010101",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#aC75yFrlW",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b2tAMyc3P",
    opacity: 1,
    fill: "#010101",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b2tAMyc3P",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#d22jpcMPgQ",
    opacity: 1,
    fill: "#010101",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#d22jpcMPgQ",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a6cE3bCkJk",
    opacity: 1,
    fill: "#010101",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a6cE3bCkJk",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b9JqJmZ18",
    opacity: 1,
    fill: "#010101",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b9JqJmZ18",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#mcy2EgNJB",
    opacity: 1,
    fill: "#00af60",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#mcy2EgNJB",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBusiness4);
export default __webpack_public_path__ + "static/media/business-4.75fbd9035b7fe51a9cdb6a662e02d490.svg";
export { ForwardRef as ReactComponent };